<apm-sidebar>
  <apm-sidebar-content>
    @if (!isLoadingWorkingConditions()) {
      <apm-formly-form-wrapper
        [form]="wcForm"
        [formModel]="wcFormModel"
        [fields]="wcFields()"
      ></apm-formly-form-wrapper>

      <div class="mt-4">
        <apm-formly-form-wrapper
          [form]="filtersForm"
          [formModel]="filtersFormModel"
          [fields]="filtersFields()"
        ></apm-formly-form-wrapper>
      </div>
    }
  </apm-sidebar-content>
  <apm-sidebar-footer>
    <hr class="gray-divider-1 my-3" />

    <apm-button class="flex-1" variant="secondary" (click)="close()">
      {{ 444686 | apmTranslate }}
    </apm-button>
  </apm-sidebar-footer>

  <apm-windowed-spinner [show]="isLoadingWorkingConditions()"></apm-windowed-spinner>
</apm-sidebar>
